module.exports = __webpack_public_path__ + "img/152.06957210.jpg";